import { environment } from "src/environments/environment";

// export const BASE_URL_OB = 'https://onboarding.services.popapp.io';
export const BASE_URL_OB = environment.urls.onboarding;
export const BASE_URL_FUNCTIONS = environment.urls.functions;

